<template>
    <div class="wrapper">
        <div class="animated fadeIn">
            <div class="row">
                <div class="col-md-12">
                    <b-card>
                        <div class="card-header">
                            <i class="fa fa-tasks"></i>
                            Lista de contribuyentes
                            <div class="pull-right">
                                <b-button variant="primary" size="sm"  @click.prevent="abrirModalAlta()">
                                    <i class="fa fa-download"></i> Alta Distribuidor
                                </b-button>
                            </div>
                        </div>
                        <dx-data-grid
                                ref="grid"
                                :dataSource="distribuidores"
                                :columns="columns"
                                :paging="paging"
                                :headerFilter="{ visible: true }"
                                :allowColumnReordering="true"
                                :allowColumnResizing="true"
                                :columnHidingEnabled="true"
                                :columnResizingMode="'widget'"
                                :filterRow="{ visible: true }"
                                :groupPanel="{ visible: true }"
                                :pager="{
                                        showPageSizeSelector: true,
                                        allowedPageSizes: [5, 10, 20],
                                        showInfo: true
                                    }"
                        >
                            <div slot="test" slot-scope="data" >
                                <div>
                                    <a href="#"  v-b-tooltip.hover title="Editar distribuidor" @click.prevent="editar(data)"><i class="fa fa-edit"></i></a>
                                    <a href="#"  v-b-tooltip.hover title="Descargar excel" @click.prevent="exportExcel(data.data)">
                                        <template v-if="data.data.Id !== loading"><i class="fa fa-download"></i></template>
                                        <template v-else><i class="fa-spin fa fa-spinner"></i></template>
                                    </a>
                                    <template v-if="data.data.Estatus">
                                        <a href="#" @click="abrirAsignador(data.data)" v-b-tooltip.hover title="Asignar timbres"><i class="fa fa-plus"></i></a>
                                    </template>
                                </div>
                            </div>
                            <div slot="Asignados" slot-scope="data">
                                {{data.data.Asignados | quantity}}
                            </div>
                            <div slot="Consumidos" slot-scope="data">
                                {{data.data.Comprados | quantity}}
                            </div>
                            <div slot="Disponibles" slot-scope="data">
                                {{data.data.Disponibles | quantity}}
                            </div>
                        </dx-data-grid>
                    </b-card>
                </div>
            </div>
        </div>
        <asignar></asignar>
        <alta></alta>
        <editar></editar>
    </div>
</template>

<script>
import Row from './row'
import Asignar from '@/views/Distribuidores/Crud/Asignar'
import Search from '@/views/Distribuidores/Search'
import Alta from '@/views/Distribuidores/Crud/Alta'
import TableHead from '@/views/components/TableHead'
import EventBus from '@/event-bus.js'
import Editar from '@/views/Distribuidores/Crud/Editar'
import { DxDataGrid } from 'devextreme-vue'
import moment from 'moment'

export default {
  name: 'distribuidores',
  components: {
    moment,
    Row,
    Asignar,
    Search,
    Alta,
    TableHead,
    Editar,
    DxDataGrid
  },
  data () {
    return {
      loading: '',
      edit: false,
      errors: {},
      draft: {},
      columns: [{
        dataField: 'Nombre',
        caption: 'Nombre',
        sortOrder: 'asc',
        cellTemplate: function (cell, info) {
          let node = ''
          node = document.createElement('a')
          node.setAttribute('href', '#/distribuidores/' + info.data.Id)
          node.className = 'nav-link ellipsis'
          node.style = 'padding: 0px;'
          var value = document.createTextNode(info.data.Nombre)
          node.appendChild(value)
          cell.append(node)
        },
        width: 300
      }, {
        dataField: 'Contacto',
        caption: 'Contacto',
        width: 250
      }, {
        dataField: 'Telefono',
        caption: 'Telefono',
        alignment: 'right',
        width: 120
      }, {
        dataField: 'Comprados',
        caption: 'Comprados',
        format: '###,###,###',
        cellTemplate: 'Consumidos',
        width: 100
      }, {
        dataField: 'Asignados',
        caption: 'Asignados',
        dataType: 'number',
        format: '###,###,###',
        cellTemplate: 'Asignados',
        width: 100
      }, {
        dataField: 'Disponibles',
        caption: 'Disponibles',
        dataType: 'number',
        format: '###,###,###',
        cellTemplate: 'Disponibles',
        width: 100
      }, {
        dataField: 'Vigencia',
        caption: 'Vigencia',
        dataType: 'date',
        alignment: 'right',
        width: 100,
        cellTemplate: function (cell, info) {
          let date = moment(info.data.Vigencia).format('DD-MMM-YYYY')
          let res = date.split('-')
          res[1] = res[1].charAt(0).toUpperCase() + res[1].slice(1)
          cell.append(res.join('-'))
        }
      }, {
        dataField: 'Estatus',
        caption: 'Status',
        alignment: 'center',
        lookup: {
          dataSource: [{name: 'Activo', value: 1}, {name: 'No Activo', value: 0}],
          valueExpr: 'value',
          displayExpr: 'name'
        },
        headerFilter: {
          dataSource: [{text: 'Activo', value: ['Estatus', '=', 1]}, {text: 'No Activo', value: ['Estatus', '=', 0]}]
        },
        width: 100,
        cellTemplate: function (cell, info) {
          let node = ''
          let icon = ''
          node = document.createElement('span')
          icon = document.createElement('i')
          icon.style = 'margin-top: 0px;'

          if (info.data.Estatus === 1) {
            node.className = 'badge badge-success'
            icon.className = 'fa fa-check'
          } else {
            node.className = 'badge badge-danger'
            icon.className = 'fa fa-close'
          }
          node.appendChild(icon)
          cell.append(node)
        }
      }, {
        dataField: '',
        alignment: 'center',
        caption: 'Tools',
        cellTemplate: 'test'
      }],
      paging: {
        pageSize: 20,
        pageIndex: 0
      }
    }
  },
  computed: {
    distribuidores () {
      return this.$store.state.distribuidores
    }
  },
  methods: {
    abrirModalAlta () {
      EventBus.$emit('abrirModalAlta', true)
    },
    filterTable (data) {
      this.filter = data
    },
    editar (data) {
      EventBus.$emit('OpenEditar', data.data)
      EventBus.$emit('disableOrderDistribuidores', true)
    },
    abrirAsignador (data) {
      EventBus.$emit('abrirModalAsignar', {Id: data.Id, Nombre: data.Nombre})
    },
    exportExcel (data) {
      this.loading = data.Id
      let promise = this.$store.dispatch('distribuidorExcel', data)
      promise.then(response => {
        this.loading = ''
        window.open(response.data.url)
      })
    }
  },
  filters: {
    quantity: function (quan) {
      return (typeof quan === 'undefined') ? quan : quan.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  created () {
    let vue = this
    let response = this.$store.dispatch('fetchDistribuidores')
    response.then(response => {
      this.$store.commit('distribuidores', response.data)
    }).catch(function () {
      vue.$store.commit('authLogout', '')
      vue.$router.push('/login')
    })
    EventBus.$on('disableOrderDistribuidores', information => {
      this.$refs.grid.instance.refresh()
    })
    EventBus.$on('filterDistribuidores', information => {
      this.orderby = information
    })
  }
}
</script>
<style>
    .right-aligment {
        text-align: right;
    }
     .ellipsis {
         text-overflow: ellipsis;
         white-space: nowrap;
         overflow: hidden;
         display: block;
     }
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/Distribuidores.vue